module.exports = __webpack_public_path__ + "static/assets/90da3d70136d2b9caeee26da935797ef.png";